import firebase from "firebase";
import React, { useState, createContext, ReactNode } from "react";

type PropState<T> = [T, React.Dispatch<React.SetStateAction<T>>];

interface BoardingFlowContextState {
  tempData?: PropState<firebase.User | null>;
  phoneExists?: PropState<boolean>;
  phoneRoute?: PropState<boolean>;
  facebookPendingCredentials?: PropState<firebase.auth.AuthCredential | null>;
  pendingEmailAddress?: PropState<string>;
  activeTab?: PropState<number>;
  phoneRouteRef?: boolean;
  openSlider?: PropState<boolean>;
  allowCloseRef?: React.MutableRefObject<boolean>;
}

export const BoardingFlowContext = createContext<BoardingFlowContextState>({});

const BoardingFlowContextProvider = (props: {
  children: ReactNode;
  openSlider: boolean;
  setOpenSlider: React.Dispatch<React.SetStateAction<boolean>>;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  allowCloseRef: React.MutableRefObject<boolean>;
}) => {
  const [tempData, setTempData] = useState<firebase.User | null>(null);
  const [phoneExists, setPhoneExists] = useState(false);
  const [phoneRoute, setPhoneRoute] = useState(false);
  const [facebookPendingCredentials, setFacebookPendingCredentials] =
    useState<firebase.auth.AuthCredential | null>(null);
  const [pendingEmailAddress, setPendingEmailAddress] = useState<string>("");
  const phoneRouteRef = React.useRef(false);

  return (
    <BoardingFlowContext.Provider
      value={{
        tempData: [tempData, setTempData],
        phoneExists: [phoneExists, setPhoneExists],
        phoneRoute: [phoneRoute, setPhoneRoute],
        facebookPendingCredentials: [
          facebookPendingCredentials,
          setFacebookPendingCredentials,
        ],
        pendingEmailAddress: [pendingEmailAddress, setPendingEmailAddress],
        activeTab: [props.activeTab, props.setActiveTab],
        phoneRouteRef: phoneRoute,
        openSlider: [props.openSlider, props.setOpenSlider],
        allowCloseRef: props.allowCloseRef,
      }}
    >
      {props.children}
    </BoardingFlowContext.Provider>
  );
};

export default BoardingFlowContextProvider;
